import { render, staticRenderFns } from "./linear.vue?vue&type=template&id=54632203&scoped=true&"
import script from "./linear.vue?vue&type=script&lang=js&"
export * from "./linear.vue?vue&type=script&lang=js&"
import style0 from "./linear.vue?vue&type=style&index=0&id=54632203&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54632203",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54632203')) {
      api.createRecord('54632203', component.options)
    } else {
      api.reload('54632203', component.options)
    }
    module.hot.accept("./linear.vue?vue&type=template&id=54632203&scoped=true&", function () {
      api.rerender('54632203', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/linear.vue"
export default component.exports